import type Quill from 'quill/core';
import type { Delta } from 'quill/core';
import React from 'react';
import QuillComponent from '../../editor/QuillComponent';
import HoverContentPreview from '../HoverContentPreview';
import styles from './HistoricalPost.module.scss';

interface HistoricalPostProps {
  content: Delta;
  onBlotComponentsInitialLoad?: (quill: Quill) => void;
}

const HistoricalPost = ({
  content,
  onBlotComponentsInitialLoad,
}: HistoricalPostProps) => {
  return (
    <div className={styles.historicalPost}>
      <HoverContentPreview>
        <QuillComponent
          rootClassName={styles.editorRoot}
          containerClassName={styles.editorContainer}
          namespace="history"
          onBlotComponentsInitialLoad={onBlotComponentsInitialLoad}
          content={content}
          readOnly
        />
      </HoverContentPreview>
    </div>
  );
};

export default HistoricalPost;
